import { v4 as generateUUID } from 'uuid';
import { invert } from 'lodash-es';
import type { RadioTextFilterValueType } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type {
  ErrorSubFilter,
  ErrorType,
} from '../../../components/StatelessComponent/SingleFilter/ErrorFilter/ErrorFilterType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import { GenericOccurredOperation } from '../../../components/StatelessComponent/SingleFilter/GenericConstants/GenericOccurredOptionList';
import { SubFilterErrorKind } from '../../../components/StatelessComponent/SingleFilter/ErrorFilter/ErrorFilterType';
import {
  QueryMapOperandEnum,
  QueryKeyEnum,
  QuerySubKeyEnum,
} from '../../../domains/global-filters/model/QueryFormat';
import {
  fromUiToQueryFormat as radioTextfromUiToQueryFormat,
  fromIntermediateToUiFormat as radioTextFromIntermediateToUiFormat,
} from './GenericConverter/RadioTextConverter';
import {
  fromUiToQueryFormat as urlfromUiToQueryFormat,
  fromIntermediateToUiFormat as urlFromIntermediateToUiFormat,
} from './URLConverter';

const subQueryValueBySubUiValue: Record<SubFilterErrorKind, QuerySubKeyEnum> = {
  [SubFilterErrorKind.PAGE_PATH]: QuerySubKeyEnum.page_path,
  [SubFilterErrorKind.TEXT]: QuerySubKeyEnum.text,
};

const subUiValueBySubQueryValue = invert(subQueryValueBySubUiValue) as Record<
  QuerySubKeyEnum,
  SubFilterErrorKind
>;

export function fromUiToQueryFormat(uiValue: ErrorType): QueryFormatFilter {
  const subFilters = uiValue.subFilters.map((item) => {
    const subKey: QuerySubKeyEnum = subQueryValueBySubUiValue[item.kind];
    return subKey === QuerySubKeyEnum.page_path
      ? urlfromUiToQueryFormat(item.value, subKey)
      : radioTextfromUiToQueryFormat(item.value, subKey);
  });
  if (uiValue.operation === GenericOccurredOperation.OCCURRED) {
    return { [QueryKeyEnum.error]: subFilters };
  }
  return { [QueryMapOperandEnum.NOT]: { [QueryKeyEnum.error]: subFilters } };
}

export function fromIntermediateToUiFormat(intermediateValue: IntermediateFormat): ErrorType {
  const subFilters: ErrorSubFilter[] = [];

  let valueIndex = 0;
  let previousOperation;
  for (let i = 0; i < intermediateValue.operation.length; i += 1) {
    const oneOperation = intermediateValue.operation[i];
    if (oneOperation !== QueryMapOperandEnum.NOT) {
      const oneSubKey = intermediateValue.subKey[valueIndex];
      const oneSubValue = intermediateValue.value[valueIndex];
      const kind: SubFilterErrorKind = subUiValueBySubQueryValue[oneSubKey];

      const negate = previousOperation === QueryMapOperandEnum.NOT;
      const value: RadioTextFilterValueType =
        oneSubKey === QuerySubKeyEnum.page_path
          ? urlFromIntermediateToUiFormat({
              type: oneSubKey,
              operation: [oneOperation],
              value: [oneSubValue],
              subKey: [],
              negate,
            })
          : radioTextFromIntermediateToUiFormat({
              type: oneSubKey,
              operation: [oneOperation],
              value: [oneSubValue],
              subKey: [],
              negate,
            });
      subFilters.push({
        id: generateUUID(),
        kind,
        value,
      });
      valueIndex += 1;
    }
    previousOperation = oneOperation;
  }
  return {
    operation:
      intermediateValue.negate === true
        ? GenericOccurredOperation.DID_NOT_OCCUR
        : GenericOccurredOperation.OCCURRED,
    subFilters,
  };
}
